import { render, staticRenderFns } from "./UserP2PRequisitesFilters.vue?vue&type=template&id=1e4fb2d8&"
import script from "./UserP2PRequisitesFilters.vue?vue&type=script&lang=js&"
export * from "./UserP2PRequisitesFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports